namespace Areas.Maintenance.List {
    "use strict";

    var systemMaintenanceTabItems = Areas.createTabsWithSameAction("Maintenance", "List",
        ["AuthorizedUser", "SystemConfigSettings", "SystemProcessEmails", "SystemUsers"]);


    export function systemMaintenanceTabInitialized(params: any) {
        return Areas.tabInitialized(systemMaintenanceTabItems)(params);
    }
}